import {useState, useCallback} from 'react';

const DEFAULT_PAGE_SIZE = 5;

export const usePagination = (pageSize: number = DEFAULT_PAGE_SIZE) => {
    const [tokenStack, setTokenStack] = useState<(string | undefined)[]>([undefined]);
    const [nextToken, setNextToken] = useState<string | undefined>(undefined);

    const currentToken = tokenStack[tokenStack.length - 1];
    const currentPage = tokenStack.length;
    const hasPrevious = tokenStack.length > 1;
    const hasNext = !!nextToken;

    const goToNextPage = useCallback(() => {
        if (nextToken) {
            setTokenStack(prev => [...prev, nextToken]);
        }
    }, [nextToken]);

    const goToPreviousPage = useCallback(() => {
        setTokenStack(prev => prev.length > 1 ? prev.slice(0, -1) : prev);
    }, []);

    const resetPagination = useCallback(() => {
        setTokenStack([undefined]);
        setNextToken(undefined);
    }, []);

    return {
        currentPage,
        pageSize,
        hasNext,
        hasPrevious,
        currentToken,
        nextToken,
        setNextToken,
        goToNextPage,
        goToPreviousPage,
        resetPagination,
    };
};
